export const Errors = {
  "The user credentials were incorrect.": "The provided credentials were incorrect."
};